class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink);
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      const sectionElement = section.selector
        ? document.querySelector(section.selector)
        : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


//////////////////

(() => {
  const DEFAULT_ERROR = 'Unable to update cart.';

  function normalizeCartError(message) {
    if (typeof message === 'string') return message;

    if (Array.isArray(message)) {
      const joinedArray = message
        .map((item) => normalizeCartError(item))
        .filter(Boolean)
        .join(', ');
      return joinedArray || DEFAULT_ERROR;
    }

    if (message && typeof message === 'object') {
      if (typeof message.message === 'string' && message.message.trim()) return message.message;
      if (typeof message.description === 'string' && message.description.trim()) return message.description;
      if (typeof message.error === 'string' && message.error.trim()) return message.error;

      if (message.errors && typeof message.errors === 'object') {
        const joinedNestedErrors = Object.values(message.errors)
          .flatMap((item) => (Array.isArray(item) ? item : [item]))
          .map((item) => normalizeCartError(item))
          .filter(Boolean)
          .join(', ');

        if (joinedNestedErrors) return joinedNestedErrors;
      }

      const joinedObjectValues = Object.values(message)
        .flatMap((item) => (Array.isArray(item) ? item : [item]))
        .map((item) => normalizeCartError(item))
        .filter(Boolean)
        .join(', ');

      if (joinedObjectValues) return joinedObjectValues;
    }

    return DEFAULT_ERROR;
  }

  function patchCartElement(tagName) {
    const constructor = window.customElements && window.customElements.get(tagName);
    if (!constructor || constructor.__afCartErrorPatched) return false;

    const proto = constructor.prototype;
    if (!proto || typeof proto.updateLiveRegions !== 'function') return false;

    const originalUpdateLiveRegions = proto.updateLiveRegions;
    proto.updateLiveRegions = function patchedUpdateLiveRegions(line, message) {
      return originalUpdateLiveRegions.call(this, line, normalizeCartError(message));
    };

    constructor.__afCartErrorPatched = true;
    return true;
  }

  function applyCartErrorPatch() {
    const cartItemsPatched = patchCartElement('cart-items');
    const cartDrawerItemsPatched = patchCartElement('cart-drawer-items');
    return cartItemsPatched || cartDrawerItemsPatched;
  }

  if (applyCartErrorPatch()) return;

  let attempts = 0;
  const retryTimer = window.setInterval(() => {
    attempts += 1;
    if (applyCartErrorPatch() || attempts > 80) {
      window.clearInterval(retryTimer);
    }
  }, 250);
})();
